/*
  RebX campaign popup.
  Waits for the cookie banner to go, then the delay; remembers per campaign when it was
  closed; hides itself outside the start/end window; leaves a reminder pill after closing.
*/
(function () {
  if (customElements.get('rx-promo')) return;

  var DAY = 864e5;

  function parseDate(v) {
    if (!v) return null;
    var d = new Date(String(v).trim().replace(' ', 'T'));
    return isNaN(d.getTime()) ? null : d;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function store(kind) {
    try { var s = window[kind]; s.setItem('__rx', '1'); s.removeItem('__rx'); return s; } catch (e) { return null; }
  }
  function cookieBannerUp() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    var cs = getComputedStyle(b);
    return cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
  }

  class RxPromo extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.dialog = this.querySelector('dialog');
      this.pill = this.querySelector('[data-promo-pill]');
      this.id_ = 'rxPromo:' + (this.dataset.id || 'campaign');
      this.design = this.hasAttribute('data-design');
      this.starts = parseDate(this.dataset.starts);
      this.ends = parseDate(this.dataset.ends);
      this.delay = Math.max(0, parseInt(this.dataset.delay, 10) || 0) * 1000;
      this.again = Math.max(0, parseInt(this.dataset.again, 10) || 0);
      this.local = store('localStorage');
      this.session = store('sessionStorage');

      this.bind();
      if (this.design) { this.open(); return; }
      if (!this.live()) return;
      if (this.seenRecently()) { this.showPill(); return; }
      this.waitThenOpen();
    }

    disconnectedCallback() { this.stopTick(); clearTimeout(this._wait); }

    live() {
      var now = Date.now();
      if (this.starts && now < this.starts.getTime()) return false;
      if (this.ends && now >= this.ends.getTime()) return false;
      return true;
    }

    seenRecently() {
      if (this.again === 0) return !!(this.session && this.session.getItem(this.id_));
      var at = this.local ? parseInt(this.local.getItem(this.id_), 10) : 0;
      return !!at && Date.now() - at < this.again * DAY;
    }

    remember() {
      if (this.design) return;
      if (this.session) this.session.setItem(this.id_, '1');
      if (this.local) this.local.setItem(this.id_, String(Date.now()));
    }

    waitThenOpen() {
      var self = this;
      var start = Date.now();
      // The cookie banner may be injected a moment after load, so give it a beat, then
      // wait until it is gone (max 2 minutes) before starting the delay.
      (function check() {
        if (Date.now() - start < 1200 || cookieBannerUp()) {
          if (Date.now() - start > 120000) return;
          self._wait = setTimeout(check, 700);
          return;
        }
        self._wait = setTimeout(function () {
          if (document.querySelector('dialog[open]:not(.rx-promo)')) { self.showPill(); return; }
          self.open();
        }, self.delay);
      })();
    }

    bind() {
      var self = this;
      this.querySelectorAll('[data-promo-close]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      // Clicking the dimmed backdrop (the dialog box itself) closes it.
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
      this.dialog.addEventListener('close', function () { self.onClosed(); });
      var go = this.querySelector('[data-promo-go]');
      if (go) go.addEventListener('click', function () { self.remember(); });

      var copy = this.querySelector('[data-promo-copy]');
      if (copy) copy.addEventListener('click', function () { self.copy(copy); });

      if (this.pill) {
        this.pill.querySelector('[data-promo-open]').addEventListener('click', function () { self.open(); });
        this.pill.querySelector('[data-promo-pill-x]').addEventListener('click', function () {
          self.pill.hidden = true;
          if (self.session) self.session.setItem(self.id_ + ':pill', 'x');
        });
      }

      if (this.design) {
        var section = this.closest('.shopify-section');
        document.addEventListener('shopify:section:select', function (e) { if (section && e.target === section) self.open(); });
        document.addEventListener('shopify:section:deselect', function (e) { if (section && e.target === section) self.close(); });
      }
    }

    open() {
      if (this.dialog.open) return;
      this._from = document.activeElement;
      if (this.pill) this.pill.hidden = true;
      try { this.dialog.showModal(); } catch (e) { this.dialog.setAttribute('open', ''); }
      document.documentElement.classList.add('rx-promo-lock');
      this.startTick();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    onClosed() {
      document.documentElement.classList.remove('rx-promo-lock');
      this.remember();
      this.showPill();
      if (this._from && this._from.focus && document.contains(this._from)) this._from.focus({ preventScroll: true });
    }

    showPill() {
      if (!this.pill || this.design) return;
      if (!this.live()) return;
      if (this.session && this.session.getItem(this.id_ + ':pill') === 'x') return;
      this.pill.hidden = false;
      this.startTick();
    }

    copy(btn) {
      var code = btn.getAttribute('data-promo-copy');
      var label = btn.querySelector('[data-promo-copy-text]');
      function done() {
        if (!label) return;
        label.textContent = 'Copied';
        clearTimeout(btn._t);
        btn._t = setTimeout(function () { label.textContent = 'Copy'; }, 2000);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        var t = document.createElement('textarea');
        t.value = code;
        t.setAttribute('readonly', '');
        t.style.position = 'fixed';
        t.style.opacity = '0';
        btn.appendChild(t);
        t.select();
        try { document.execCommand('copy'); } catch (e) {}
        t.remove();
        done();
      }
    }

    startTick() {
      if (!this.ends || this._tick) return;
      var self = this;
      this.tick();
      this._tick = setInterval(function () { self.tick(); }, 1000);
    }
    stopTick() { clearInterval(this._tick); this._tick = null; }

    tick() {
      var left = this.ends.getTime() - Date.now();
      if (left <= 0 && !this.design) {
        this.stopTick();
        this.close();
        if (this.pill) this.pill.hidden = true;
        return;
      }
      left = Math.max(left, 0);
      var secs = Math.floor(left / 1000);
      var d = Math.floor(secs / 86400);
      var h = Math.floor((secs % 86400) / 3600);
      var m = Math.floor((secs % 3600) / 60);
      var s = secs % 60;

      var timer = this.querySelector('[data-promo-timer]');
      if (timer) {
        timer.querySelector('[data-d]').textContent = pad(d);
        timer.querySelector('[data-h]').textContent = pad(h);
        timer.querySelector('[data-m]').textContent = pad(m);
        timer.querySelector('[data-s]').textContent = pad(s);
        timer.hidden = false;
      }
      var pt = this.pill && this.pill.querySelector('[data-promo-pill-time]');
      if (pt) {
        pt.textContent = d > 0 ? 'Ends in ' + d + 'd ' + h + 'h' : 'Ends in ' + h + 'h ' + pad(m) + 'm';
        pt.hidden = false;
      }
      // Nothing visible to update: stop until the popup or pill shows again.
      if (!this.dialog.open && (!this.pill || this.pill.hidden)) this.stopTick();
    }
  }

  customElements.define('rx-promo', RxPromo);
})();
